import { useEffect, useState } from "react";
import { TrendingUp, Loader2, SearchX, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminSearchAnalytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/analytics/searches");
      setData(data);
    } catch {
      toast.error("Analitik yüklenemedi");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const clear = async () => {
    if (!window.confirm("Tüm arama kayıtları silinsin mi?")) return;
    try { await api.delete("/admin/analytics/searches"); toast.success("Temizlendi"); load(); }
    catch { toast.error("Silinemedi"); }
  };

  return (
    <div data-testid="admin-search-analytics-page">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <TrendingUp className="text-gold" size={22} />
          <h1 className="font-display text-3xl text-foreground">Arama Analitiği</h1>
        </div>
        {data && data.total > 0 && (
          <button data-testid="clear-analytics-button" onClick={clear} className="flex items-center gap-1.5 px-3 h-9 border border-border rounded-md text-sm text-muted-foreground hover:text-red-400 transition-colors">
            <Trash2 size={15} /> Temizle
          </button>
        )}
      </div>
      <p className="text-sm text-muted-foreground mb-6">Müşterilerin ne aradığını görün; sonuç bulunamayan aramalar katalog boşluklarını gösterir.</p>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="animate-spin text-gold" size={26} /></div>
      ) : !data || data.total === 0 ? (
        <p className="text-muted-foreground text-sm py-12 text-center border border-dashed border-border rounded-lg">Henüz arama kaydı yok.</p>
      ) : (
        <>
          <div className="flex gap-4 mb-6">
            <div className="bg-surface border border-border rounded-lg px-5 py-3" data-testid="stat-total">
              <p className="text-2xl font-display text-gold">{data.total}</p>
              <p className="text-xs text-muted-foreground">Toplam arama</p>
            </div>
            <div className="bg-surface border border-border rounded-lg px-5 py-3" data-testid="stat-zero">
              <p className="text-2xl font-display text-amber-400">{data.zero_total}</p>
              <p className="text-xs text-muted-foreground">Sonuçsuz arama</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <section data-testid="top-searches">
              <h2 className="text-sm font-medium text-foreground/80 mb-3 flex items-center gap-2"><TrendingUp size={15} className="text-gold" /> En Çok Aranan</h2>
              <div className="space-y-1.5">
                {data.top.length === 0 && <p className="text-xs text-muted-foreground">Kayıt yok.</p>}
                {data.top.map((t) => (
                  <div key={t.term} data-testid={`top-term-${t.term}`} className="flex items-center justify-between bg-surface border border-border rounded-md px-3 py-2 text-sm">
                    <span className="text-foreground truncate">{t.term}</span>
                    <span className="text-xs text-muted-foreground shrink-0 ml-2">{t.count}× · ort. {t.avg_results} sonuç</span>
                  </div>
                ))}
              </div>
            </section>

            <section data-testid="no-result-searches">
              <h2 className="text-sm font-medium text-foreground/80 mb-3 flex items-center gap-2"><SearchX size={15} className="text-amber-400" /> Sonuç Bulunamayan</h2>
              <div className="space-y-1.5">
                {data.no_result.length === 0 && <p className="text-xs text-muted-foreground">Harika — sonuçsuz arama yok.</p>}
                {data.no_result.map((t) => (
                  <div key={t.term} data-testid={`noresult-term-${t.term}`} className="flex items-center justify-between bg-surface border border-amber-500/20 rounded-md px-3 py-2 text-sm">
                    <span className="text-foreground truncate">{t.term}</span>
                    <span className="text-xs text-amber-400/80 shrink-0 ml-2">{t.count}×</span>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </>
      )}
    </div>
  );
}
